
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store/category/[data]",
      function () {
        return require("private-next-pages/[lang]/store/category/[data].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store/category/[data]"])
      });
    }
  